module.exports = "./img/fec2abc6a6fcd6a4029757f229665cbb.jpg";